import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  payment: {},
  titleName: '',
  autobill: '',
  disableData: '',
};
const PGslice = createSlice({
  name: 'Pg',
  initialState,
  reducers: {
    paynow: (state, action) => {
      state.payment = action.payload;
    },
    breadcrumbAction: (state, action) => {
      state.titleName = action.payload;
    },
    autobillAction: (state, action) => {
      state.autobill = action.payload;
    },
    disableAutobillingData: (state, action) => {
      state.disableData = action.payload;
    },
    resetPGState: () => initialState
  },
});

export const { paynow, breadcrumbAction, autobillAction, disableAutobillingData, resetPGState } = PGslice.actions;
export default PGslice.reducer;
